import { SaveOutlined } from '@ant-design/icons';
import { useFormStateIsDirty } from '@framework/form';
import { useTranslation } from '@framework/i18n';
import {
  AsyncButton,
  ButtonResponsiveProps,
  getResponsiveButtonProps,
} from '@framework/ui';
import { ButtonProps, Tooltip } from 'antd';
import React, { useMemo } from 'react';
import { useFormState } from 'react-hook-form';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import { useHandleDraftSubmit } from './useHandleDraftSubmit';

export interface IDraftSubmitFormButtonProps extends ButtonProps {
  onValid: (data: any) => Promise<void>;
}

/**
 * Come il SubmitFormButton, ma salva il form in bozza.
 * Utilizza useHandleDraftSubmit per creare un processo semplificato
 * di submit del form che, in caso di successo, chiama una funzione
 * passata come prop.
 */
export function DraftSubmitFormButton(props: IDraftSubmitFormButtonProps) {
  const { onValid, ...otherProps } = props;
  // Destructuring obbligatorio per il corretto funzionamento di useFormState
  const { isSubmitting } = useFormState();
  const isDirty = useFormStateIsDirty();
  const { t } = useTranslation();

  const isMobile = useBreakpoint(down('md'));
  const buttonResponsiveProps = useMemo(() => {
    return getResponsiveButtonProps(
      {
        // icon: <SaveOutlined />,
        iconLeftComponent: SaveOutlined,
        iconLeftAriaLabel: t('form.salva', 'Salva'),
        text: t('form.salva', 'Salva'),
        ...otherProps,
      } satisfies ButtonResponsiveProps,
      isMobile,
    );
  }, [t, otherProps, isMobile]);

  const handleSubmit = useHandleDraftSubmit({
    onValid,
  });

  return (
    <Tooltip
      title={
        isDirty
          ? undefined
          : t(
              'form.non-ci-sono-modifiche',
              'Non ci sono modifiche da salvare',
            )
      }
    >
      <AsyncButton
        // icon={<SaveOutlined />}
        type="primary"
        size="large"
        // children={t('front:form.salva', 'Salva')}
        {...buttonResponsiveProps}
        loading={isSubmitting}
        disabled={!isDirty}
        onClick={handleSubmit}
      />
    </Tooltip>
  );
}
